import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _CardTypeDisplayedNam;
export var CardTypes = {
  AMERICANEXPRESS: 'americanexpress',
  AMEX: 'amex',
  APPLEPAY: 'apple pay',
  CREDITCARD: 'credit card',
  DISCOVER: 'discover',
  GIFTCODE: 'gift code',
  JCB: 'jcb',
  MASTERCARD: 'mastercard',
  PAYPAL: 'paypal token',
  VENMO: 'venmo',
  VISA: 'visa',
  GOOGLEPAY: 'GOOGLE_PAY',
  RUPAY: 'rupay',
  DINERSCLUB: 'diners club',
  UNIONPAY: 'union pay'
};

//TODO: refactor ACCOUNT_TYPE and CardTypes into one?
export var ACCOUNT_TYPE = /*#__PURE__*/function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE["APPLE_PAY"] = "apple pay";
  ACCOUNT_TYPE["BALANCE"] = "balance";
  ACCOUNT_TYPE["CREDIT_CARD"] = "credit card";
  ACCOUNT_TYPE["GIFT_CODE"] = "gift code";
  ACCOUNT_TYPE["PAYPAL_TOKEN"] = "paypal token";
  ACCOUNT_TYPE["VENMO"] = "venmo";
  ACCOUNT_TYPE["UPI"] = "upi";
  ACCOUNT_TYPE["GOOGLE_PAY"] = "GOOGLE_PAY";
  ACCOUNT_TYPE["PLACEHOLDER"] = "PLACEHOLDER";
  return ACCOUNT_TYPE;
}({});
export var WalletMOP = [ACCOUNT_TYPE.APPLE_PAY, ACCOUNT_TYPE.GOOGLE_PAY, ACCOUNT_TYPE.PAYPAL_TOKEN, ACCOUNT_TYPE.VENMO];
export var CardTypeDisplayedNames = (_CardTypeDisplayedNam = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CardTypeDisplayedNam, CardTypes.AMERICANEXPRESS, 'American Express'), CardTypes.AMEX, 'American Express'), CardTypes.APPLEPAY, 'Apple Pay'), CardTypes.DISCOVER, 'Discover'), CardTypes.GIFTCODE, 'Gift Code'), CardTypes.GOOGLEPAY, 'GOOGLE_PAY'), CardTypes.JCB, 'JCB'), CardTypes.MASTERCARD, 'MasterCard'), CardTypes.PAYPAL, 'PayPal'), CardTypes.VENMO, 'Venmo'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_CardTypeDisplayedNam, CardTypes.VISA, 'Visa'), CardTypes.RUPAY, 'RuPay'), CardTypes.DINERSCLUB, 'Diners Club'), CardTypes.UNIONPAY, 'Union Pay'));
export var PaymentMethods = /*#__PURE__*/function (PaymentMethods) {
  PaymentMethods["PAYPAL"] = "paypal";
  PaymentMethods["APPLEPAY"] = "applepay";
  PaymentMethods["CREDITCARD"] = "creditcard";
  PaymentMethods["YIFTEE"] = "yiftee";
  PaymentMethods["VENMO"] = "venmo";
  PaymentMethods["UPI"] = "upi";
  PaymentMethods["GOOGLE_PAY"] = "GOOGLE_PAY";
  return PaymentMethods;
}({});
export var PAYMENT_METHOD_FILTER_TYPES = /*#__PURE__*/function (PAYMENT_METHOD_FILTER_TYPES) {
  PAYMENT_METHOD_FILTER_TYPES["CREDIT_CARD"] = "credit card";
  PAYMENT_METHOD_FILTER_TYPES["PAYPAL"] = "paypal";
  PAYMENT_METHOD_FILTER_TYPES["VENMO"] = "venmo";
  PAYMENT_METHOD_FILTER_TYPES["YIFTEE"] = "yiftee";
  PAYMENT_METHOD_FILTER_TYPES["GOOGLE_PAY"] = "GOOGLE_PAY";
  return PAYMENT_METHOD_FILTER_TYPES;
}({});

// Maps from BE to FE readable values
export var paymentMethodsToFilters = new Map([[PaymentMethods.APPLEPAY, null], [PaymentMethods.CREDITCARD, PAYMENT_METHOD_FILTER_TYPES.CREDIT_CARD], [PaymentMethods.PAYPAL, PAYMENT_METHOD_FILTER_TYPES.PAYPAL], [PaymentMethods.VENMO, PAYMENT_METHOD_FILTER_TYPES.VENMO], [PaymentMethods.YIFTEE, PAYMENT_METHOD_FILTER_TYPES.YIFTEE], [PaymentMethods.GOOGLE_PAY, PAYMENT_METHOD_FILTER_TYPES.GOOGLE_PAY]]);
export var accountTypeToPaymentMethods = new Map([[ACCOUNT_TYPE.APPLE_PAY, PaymentMethods.APPLEPAY], [ACCOUNT_TYPE.CREDIT_CARD, PaymentMethods.CREDITCARD], [ACCOUNT_TYPE.GIFT_CODE, PaymentMethods.YIFTEE], [ACCOUNT_TYPE.PAYPAL_TOKEN, PaymentMethods.PAYPAL], [ACCOUNT_TYPE.VENMO, PaymentMethods.VENMO], [ACCOUNT_TYPE.UPI, PaymentMethods.UPI], [ACCOUNT_TYPE.GOOGLE_PAY, PaymentMethods.GOOGLE_PAY]]);

// A Mapping from Recurly to UI
export var recurlyMopTypeToPaymentMethods = new Map([['AMERICAN_EXPRESS', CardTypes.AMERICANEXPRESS], ['DISCOVER', CardTypes.DISCOVER], ['JCB', CardTypes.JCB], ['MASTERCARD', CardTypes.MASTERCARD], ['VISA', CardTypes.VISA], ['DINERS_CLUB', CardTypes.DINERSCLUB], ['CREDIT_CARD', PaymentMethods.CREDITCARD], ['BRAINTREE_V_ZERO', CardTypes.PAYPAL], ['BRAINTREE_APPLE_PAY', CardTypes.APPLEPAY], ['VENMO', CardTypes.VENMO], ['GOOGLE_PAY', CardTypes.GOOGLEPAY], ['UNION_PAY', CardTypes.UNIONPAY]]);

// Common Venmo errors
export var VENMO_APP_CANCELED = 'VENMO_APP_CANCELED';
export var VENMO_CANCELED = 'VENMO_CANCELED';
export var FRAME_SERVICE_FRAME_CLOSED = 'FRAME_SERVICE_FRAME_CLOSED';
export var VENMO_TOKENIZATION_CANCELED_BY_MERCHANT = 'VENMO_TOKENIZATION_CANCELED_BY_MERCHANT';
export var VENMO_TOKENIZATION_REQUEST_ACTIVE = 'VENMO_TOKENIZATION_REQUEST_ACTIVE';

// Common PayPal errors
export var PAYPAL_POPUP_CLOSED = 'PAYPAL_POPUP_CLOSED';
export var PAYPAL_TOKENIZATION_REQUEST_ACTIVE = 'PAYPAL_TOKENIZATION_REQUEST_ACTIVE';

// Common ApplePay errors
// There are no common ApplePay errors to avoid: https://braintree.github.io/braintree-web/current/BraintreeError.html

export var mopGeneric = {
  message_name: 'payment processing issue',
  message_detail: 'There was an issue while processing your payment information. Your account has not been charged. Please try again or use different payment method.',
  message_id: 'mop.generic' //replace with actual error
};

export var CARD_ANNOUNCEMENT_ID = 'card-announcement';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/constants/PaymentTypes.js
// module id = 41
// module chunks = 11